import type { ReactNode } from "react";

interface ReportLinkProps {
  href: string;
  children: ReactNode;
}

const ReportLink = ({ href, children }: ReportLinkProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block underline transition-transform hover:scale-105 hover:text-blue-600"
    >
      {children}
    </a>
  );
};

export default ReportLink;
